import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";

export interface CartNumberProps {
  cartValue: number;
  shouldShow: boolean;
  merchantColor: string;
  suppressNavigationUi?: boolean;
}
export const CartNumber = ({
  cartValue,
  shouldShow,
  merchantColor,
  suppressNavigationUi = false,
}: CartNumberProps) => {
  return (
    shouldShow && (
      <span
        data-testid={
          suppressNavigationUi
            ? undefined
            : applyDataTestId(pom.header.cartNumber)
        }
        className="absolute flex left-2 top-2"
        aria-hidden="true"
      >
        <div
          style={{ backgroundColor: merchantColor }}
          className="flex items-center justify-center text-white rounded-full w-5 h-5 text-xs"
        >
          {`${cartValue || "$"}`}
        </div>
      </span>
    )
  );
};
